import { createContext } from 'react'

export interface EAReportContextValue {
  title: string
}

const EAReportContext = createContext<EAReportContextValue | null>(null)

export default EAReportContext
